export default __webpack_public_path__ + "static/media/offers.0ee1d9ab.jpg";